/** Identical to `Object.keys()` except that it returns a typesafe array of all string keys. */
export const safeKeysOf = <T extends object>(obj: T) =>
  Object.keys(obj).filter((_it): _it is keyof T & string => true);
